import { render } from "./header-wrapper.vue?vue&type=template&id=61875de3&scoped=true"
import script from "./header-wrapper.vue?vue&type=script&lang=js"
export * from "./header-wrapper.vue?vue&type=script&lang=js"

import "./header-wrapper.vue?vue&type=style&index=0&id=61875de3&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61875de3"],['__file',"src/components/header-wrapper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "61875de3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('61875de3', __exports__)) {
    api.reload('61875de3', __exports__)
  }
  
  module.hot.accept("./header-wrapper.vue?vue&type=template&id=61875de3&scoped=true", () => {
    api.rerender('61875de3', render)
  })

}


export default __exports__